import { t } from 'ttag'
import { useMutation } from 'react-query'
import { useContext, useEffect, useState } from 'react'

import { api, errors } from '@h2/api'
import { useForm } from '@h2/common/components/hooks/useForm'
import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Button } from '@h2/components/buttons/button'
import { Field } from '@h2/components/inputs/field'
import { Switch } from '@h2/components/inputs/switch'
import { Select } from '@h2/components/inputs/select'
import { Modal } from '@h2/components/containers/modal'
import { Heading } from '@h2/components/typography/heading'
import { SubmitCircleIcon } from '@h2/components/icons'
import { Globals } from '@h2/globals'

const ApprovalActionsContent = ({ assignmentId, toggleModal, onSuccess }) => {
  const { isNavianceElementary, userProfile } = useContext(Globals)
  const [fileTags, setFileTags] = useState([]) //useSelector(state => state.fileManagementWizard.data.tags)
  const [saveApprovedToPDF, setSaveApprovedToPDF] = useState(false)
  const toggleSaveApproved = () => {
    setSaveApprovedToPDF(!saveApprovedToPDF)
  }
  const resetSaveApproved = () => {
    setSaveApprovedToPDF(false)
  }

  useEffect(() => {
    const getTags = async () => {
      const tags = await api.fetch('/user/tags', { version: `v1` })

      setFileTags(tags)
    }

    getTags()
  }, [])
  const {
    register: registerApprovalForm,
    isInvalid: isInvalidApprovalForm,
    handleOnSubmit: handleOnSubmitApprovalForm,
    dispatch: dispatchApprovalForm,
    error
  } = useForm({})
  const { mutate: mutateApproval, isLoading: isApprovalLoading } = useMutation(
    body => {
      const selectedTagValues = body.tag
      const tag =
        saveApprovedToPDF && selectedTagValues ? `${selectedTagValues.value}` : null

      return api.fetch(`/management/assignments/approve/${assignmentId}`, {
        method: 'PUT',
        body: JSON.stringify({
          savePDF: saveApprovedToPDF,
          tag
        })
      })
    },
    {
      onSuccess: data => {
        data.affectedPlans.forEach(assignment => onSuccess(assignment))
        resetSaveApproved()
        toggleModal()
      },
      onError: err => {
        const formErrors = errors.getValidation(err)

        if (formErrors) {
          dispatchApprovalForm({ type: 'validate', payload: formErrors })
        }
      }
    }
  )

  return (
    <div>
      <form onSubmit={handleOnSubmitApprovalForm(form => mutateApproval(form))}>
        {userProfile.hasFileAccess && (
          <Switch
            isOn={saveApprovedToPDF}
            label={t`Save Approved PDF to User's Files`}
            onChange={toggleSaveApproved}
          />
        )}
        {userProfile.hasFileAccess && !isNavianceElementary && (
          <Field
            desc={error.tag}
            status={error.tag ? 'error' : 'default'}
            label={t`Tag File With:`}>
            <Select
              disabled={!saveApprovedToPDF}
              items={fileTags?.map(tag => ({
                label: tag.name,
                value: tag.id
              }))}
              {...registerApprovalForm('tag')}
            />
          </Field>
        )}
        <Flex justifyContent="space-between">
          <Box width="250px">
            <Button
              type="submit"
              size="large"
              align="center"
              isLoading={isApprovalLoading}
              isDisabled={isApprovalLoading || isInvalidApprovalForm}>
              {t`Approve`}
            </Button>
          </Box>
        </Flex>
      </form>
    </div>
  )
}
const ApprovalActions = ({ assignmentId, isOpen, toggleModal, onSuccess }) => {
  return (
    <Modal isOpen={isOpen} closeOnClickOverlay={true} onClose={toggleModal}>
      <Modal.Header>
        <Heading level="3">
          <SubmitCircleIcon /> {t`Approve Assignment`}
        </Heading>
      </Modal.Header>
      <Modal.Body>
        <ApprovalActionsContent
          assignmentId={assignmentId}
          toggleModal={toggleModal}
          onSuccess={onSuccess}
        />
      </Modal.Body>
    </Modal>
  )
}

export { ApprovalActions }
